module.exports = __webpack_public_path__ + "static/img/clothing_05.20813e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_05.png
// module id = ANWk
// module chunks = 0